import { createFileRoute } from '@tanstack/react-router';
import { parseInventorySearch } from '@features/warehouse-inventory';

export const Route = createFileRoute('/$locale/_authenticated/warehouse/inventory')({
  validateSearch: parseInventorySearch,
});
